<template>
    <a
        v-if="useEncoded && actor.encoded_id"
        :href="staffUrl + actor.encoded_id"
        class="text-bold text-primary"
        :target="newTab ? '_blank' : '_self'"
        >{{ text || actor.name }}</a
    >
    <a
        v-else-if="!useRouter && actor.ci_url"
        :href="'..' + actor.ci_url"
        :target="newTab ? '_blank' : '_self'"
    >
        {{ text || actor.name }}
    </a>
    <span v-else>
        {{ text || actor.label }}
    </span>
</template>
<script>
export default {
    name: "actorName",
    props: {
        actor: {
            type: Object,
            required: true,
            default: () => {}
        },
        /**
         * text: label shown. if not specified, client.label will be used
         */
        text: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        },
        /**
         * useEncoded: true = use view staff link with encoded id, false = use ci_url
         */
        useEncoded: {
            type: Boolean,
            default: false
        },
        newTab: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        staffUrl: "/view/settings/users/view/"
    })
};
</script>
